<template>
  <form :ref="customizeWhitelabelFormRef" method="POST">
    <input
      type="hidden"
      name="__RequestVerificationToken"
      :value="antiforgeryToken"
    />
    <div class="row">
      <div class="column small-12">
        <p class="mbm">
          {{ unPrettierNuggets.blurb }}
        </p>
        <label for="whitelabel-text">
          <strong class="text-black">Texto de la marca blanca</strong>
        </label>
        <span>El texto será situado sobre las imágenes</span>
        <img
          :ref="whitelabelTextTooltipRef"
          class="has-tip top mls"
          data-tooltip
          aria-haspopup="true"
          data-allow-html="true"
          data-tooltip-class="tooltip"
          :src="questionIconUrl"
          alt="question mark icon"
          title="<strong class='text-black'>Texto de la marca blanca</strong>
            <br />
            Este es el texto que se mostrará como marca de agua sobre las imágenes y el branding para el PDF y páginas de cliente. Para mejores resultados, te recomendamos mantener el texto entre 15 y 25 caracteres de largo.
            <br />
            Ejemplo: <em>Ejemplo de Mi Empresa</em>"
        />
        <input
          id="whitelabel-text"
          v-model="whiteLabelTextValue"
          type="text"
          name="Text"
        />

        <label for="whitelabel-logo-url">
          <strong class="text-black">Tu logo (Imagen URL)</strong>
        </label>
        <span>
          {{ unPrettierNuggets.logoBlurb }}
        </span>
        <img
          :ref="whitelabelImageTooltipRef"
          class="has-tip right"
          data-tooltip
          aria-haspopup="true"
          data-allow-html="true"
          data-tooltip-class="tooltip"
          :src="questionIconUrl"
          alt="question mark icon"
          title="<strong class='text-black'>Whitelabel Image</strong>
            <br />
            Este es el enlace de la ubicación de la imagen para tu logo. Para mejores resultados, te recomendamos en logo de 250 pixeles de ancho por 150 pixeles de alto.
            <br />
            Si tienes un logo en tu sitio web que quieras ocupar, sólo haz click derecho en la imagen y selecciona «propiedades». Luego veras el URL que puedes copiay y pegar aqui.
            <br />Ejemplo: <em>http://www.example.com/mylogo.jpg</em>"
        />
        <input
          id="whitelabel-logo-url"
          v-model="whiteLabelImageUrlValue"
          type="text"
          name="ImageUrl"
        />
        <img
          v-if="whitelabelImageUrl"
          class="mbm"
          :src="whitelabelImageUrl"
          alt="whitelabel logo preview"
        />
      </div>
    </div>
    <div class="row align-center form-stacking form-stacking--medium">
      <div class="column small-12">
        <hr class="horizontal-rule horizontal-rule--form-frame-small mbm" />
      </div>
      <div class="column small-12 large-shrink">
        <button
          class="form-stacking__item button primary full-width"
          @click="onClickSaveDetails"
        >
          Guardar detalles
        </button>
      </div>
      <div class="column small-12 large-shrink">
        <button
          class="form-stacking__item button secondary hollow full-width"
          @click="onClickSaveDetailsAndPreviewPdf"
        >
          Guardar y ver PDF
        </button>
      </div>
      <div class="column medium-12 large-shrink">
        <button
          class="button secondary hollow full-width mbn"
          @click="onClickSaveDetailsAndPreviewClientPortal"
        >
          Guardar y ver portal del cliente
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    questionIconUrl: {
      type: String,
      default: '',
    },
    whitelabelText: {
      type: String,
      default: undefined,
    },
    whitelabelImageUrl: {
      type: String,
      default: undefined,
    },
    saveDetailsApi: {
      type: String,
      default: undefined,
    },
    saveDetailsPreviewPdfApi: {
      type: String,
      default: undefined,
    },
    saveDetailsPreviewClientPortalApi: {
      type: String,
      default: undefined,
    },
    antiforgeryToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      customizeWhitelabelFormRef: 'js-customize-whitelabel-form',
      whiteLabelTextValue: this.whitelabelText,
      whiteLabelImageUrlValue: this.whitelabelImageUrl,
      whitelabelTextTooltip: null,
      whitelabelImageTooltip: null,
      whitelabelTextTooltipRef: 'js-whitelabel-text-tooltip',
      whitelabelImageTooltipRef: 'js-whitelabel-image-tooltip',
      unPrettierNuggets: {
        blurb: `Esta página te da la abilidad de personalizar el branding de tu Portal de Cliente y PDF que se genera cuando compartes con tus clientes. Al hacer esto, puedar dar la impresión que el archivo fue generado por ti.`,
        logoBlurb: `Imagen que es mostrada como tu logo en el Portal y PDF (Tamaño recomendado: acho 300px y altura 100px))`,
      },
    };
  },
  mounted() {
    if (window.Foundation && window.$) {
      this.whitelabelTextTooltip = new window.Foundation.Tooltip(
        // eslint-disable-next-line no-undef
        $(this.$refs[this.whitelabelTextTooltipRef]),
      );

      this.whitelabelImageTooltip = new window.Foundation.Tooltip(
        // eslint-disable-next-line no-undef
        $(this.$refs[this.whitelabelImageTooltipRef]),
      );
    }
  },
  methods: {
    onClickSaveDetails(event) {
      event.preventDefault();
      this.$refs[this.customizeWhitelabelFormRef].action = this.saveDetailsApi;
      this.$refs[this.customizeWhitelabelFormRef].submit();
    },
    onClickSaveDetailsAndPreviewPdf(event) {
      event.preventDefault();
      this.$refs[this.customizeWhitelabelFormRef].action =
        this.saveDetailsPreviewPdfApi;
      this.$refs[this.customizeWhitelabelFormRef].submit();
    },
    onClickSaveDetailsAndPreviewClientPortal(event) {
      event.preventDefault();
      this.$refs[this.customizeWhitelabelFormRef].action =
        this.saveDetailsPreviewClientPortalApi;
      this.$refs[this.customizeWhitelabelFormRef].submit();
    },
  },
};
</script>
